import React, { Component } from "react";
import { Center, Text, Tag, Spacer, Box, Image, VStack, HStack, Button } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import ConfigService from "../../../../services/ConfigService";
import LocalImageDbService from "../../../../services/LocalImageDbService";


const DelSwal = withReactContent(Swal);

export default class UserImageDisplay extends Component 
{

    constructor(props) {
        super(props);
        this.state = {
            isLocal: null,
            src: null,
            fallbackImgSrc: null,
            errored: false
        }

        this.configService = new ConfigService();
        this.localImageDbService = new LocalImageDbService();

        this.onRemoveRequest = this.onRemoveRequest.bind(this);
        this.localImageDbService = new LocalImageDbService();
    }

    async componentDidMount()
    {

        var isLocalResult = await this.localImageDbService.hasImage(this.props.gcid, this.props.card.id);
        var isLocal = (isLocalResult.data);
        var originalImgSrc = (isLocal) ?        
            (this.props.card.thumbnailUri) ? this.props.card.thumbnailUri : this.props.card.dataUri
            : new ConfigService().getGcidUserImageBasePath(this.props.gcid) + this.props.card.thumbnailId + "." + this.props.card.ext;
        var fallbackImgSrc = this.configService.getGlasschainCommonImagePath() + "ImageNotFound.png";
        this.setState({
          src: originalImgSrc,
          fallbackImgSrc: fallbackImgSrc,
          isLocal: isLocal
        });
    }



    onRemoveRequest()
    {
        // confirm
        DelSwal.fire
        (
          {
            icon: "question",
            title: "Remove Image?",
            text: "Confirm you want to remove the image",
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel"
          }
        ).then(async (result) => {
          if (result.value) 
          {
            // now delete this image from the valuebag value
            var workingUserImages = this.props.valueBag["userimages"];
            var i = workingUserImages.findIndex((img) => img.id === this.props.card.id);
            workingUserImages.splice(i,1);
            var hasLocalImageResponse = await this.localImageDbService.hasImage(this.props.gcid, this.props.card.id);
            if (hasLocalImageResponse.data)
            {
                await this.localImageDbService.deleteImage(this.props.card.id);
                await this.localImageDbService.deleteImage(this.props.card.thumbnailId);
            }
            if (workingUserImages.length < 1)
            {
                // we also need to update the hasUserImages property
                this.props.onValueChange('hasImages', false);
            }
            this.props.onValueChange("userimages", workingUserImages);
            this.props.removeSchemaCard("notes", "Images", this.props.card.id); 
            return DelSwal.fire({ icon: "success", text: "The image has been permanently deleted." });
          }
        }
        );
    }

    onError = () => {
        if (!this.state.errored) {
          this.setState({
            src: this.state.fallbackImgSrc,
            isErrored: true,
          });
        }
    }


    render() 
    {
        // the image may be local or it may be in the cloud. If it exists locally, then let's use that one.
       
         var displayValue = (this.props.card.descript) ? this.props.card.descript : this.props.card.id; //this.props.cardValue;
        return (

            <VStack>
                <Box>
                    { (!this.props.card.disallowRemove) &&
                      <FontAwesomeIcon left="100%" style={{position: "absolute", border: "2px solid black", margin: "2px", backgroundColor: "black"}} icon={faXmark} color='white' onClick={(e) => this.onRemoveRequest(e)} />
                    }
                    <img src={this.state.src} onError={(e) => this.onError(e)} borderRadius="5px" alt="user image" maxH="10vw" />          
                </Box>
                <Text fontSize={{ base: '14px', md: '20px', lg: '24px' }} color="#0095c8" margin='0'>{displayValue}</Text>
                <HStack spacing="5px">
                {
                    (this.props.card?.tags) ?
                        this.props.card?.tags.map((t) => { return <Tag>{t.label}</Tag> })
                        : <span />
                }
                </HStack >
            </VStack>

        )
    }
}








